<!-- Interest Shared Modal -->
<div #interestSharedPopup class="modal fade interestSharedPopup" id="interestSharedPopup" tabindex="-1"
    aria-labelledby="interestSharedPopupLabel">
    <div class="modal-dialog modal-dialog-bottom">
        <div class="modal-content">
            <div class="modal-body pt-4">
                <div class="text-end">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancel()"></button>
                </div>
                <div class="inner-content" *ngIf="contactData">
                    <p class="info-text">
                        Your mobile number<br>
                        and profile details <br>
                        will be shared with
                    </p>
                    <h5 class="dealer-name mb-0">{{ contactData.brandName }}</h5>
                    <p class="note">You should receive a call from them.</p>
                    <div class="profile">
                        <div class="img-outer">
                            <img [src]="contactData.userImageUrl" alt="User Image">
                        </div>
                        <img src="assets/images/Vector.png" alt="">
                        <div class="img-outer">
                            <img [src]="contactData.companyLogoUrl" alt="User Image">
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center">
                        <input type="checkbox" id="checkbox" class="me-3 form-check-input" (change)="onCheckboxChange($event)" [(ngModel)]="doNotShowAgain">
                        <label for="checkbox">Do not show this message again.</label>
                    </div>

                    <div class="btn-outer mt-4">
                        <button type="button" class="btn cancel-btn" data-bs-dismiss="modal" (click)="onCancel()">Cancel</button>
                        <button type="button" class="btn continue-btn" (click)="onConfirm()" [style.background-color]="contactData.color">Okay</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>